/**
 * 名稱 : loadImage
 * 功能 : 載入指定靜態資源
 * @param name image-name
 * @returns string
 */
export const loadImage = (name: string): string => {
  if (name) {
    return require(`../../assets/${name}`).default;
  }
  return '';
};
